/**
 * The below file contains the fire state objects
 * @author: shivam.sharma2@velsof.com
 * @date : 10-01-2023
 */

import { AUTH_TOKEN } from "redux/constants/Auth";
import {
  SET_ALL_FIRE_CATEGORY,
} from "redux/constants/FireCategory";

//Initial state
const initState = {
  // Keys for dropdown 
  fireCategories: [],
  isFireCategoriesDataFetched: false,
  // Keys for dropdown 
};

/**
 * The below function will update the state on the basis of action type.
 * @param {any} state State
 * @param {any} action Action
 * @returns Json object
 */
const fireCategory = (state = initState, action) => {
  switch (action.type) {
    //Cases for Fire category dropdown
    case SET_ALL_FIRE_CATEGORY:
      return {
        ...state,
        fireCategories: action.payload,
        isFireCategoriesDataFetched:
          Object.keys(action.payload).length > 0 ? true : false,
      };
    //Cases for Fire category dropdown

    default:
      return state;
  }
};

export default fireCategory;
